import { Component, Input, OnInit, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AdService, ServedAd } from '@app/services/ad.service';

@Component({
  selector: 'app-ad-banner',
  standalone: true,
  imports: [CommonModule],
  template: `
    @if (ad) {
      <div class="ad-banner-container">
        <span class="ad-banner-label">Sponsored</span>
        <div class="ad-banner" (click)="onClick()">
          @if (ad.imageUrl) {
            <img [src]="ad.imageUrl" [alt]="ad.headline" class="ad-banner-img">
          } @else {
            <div class="ad-banner-fallback">
              <span class="ad-banner-headline">{{ ad.headline }}</span>
              <span class="ad-banner-desc">{{ ad.displayUrl }}</span>
              @if (ad.callToAction) {
                <span class="ad-banner-cta">{{ formatCta(ad.callToAction) }}</span>
              }
            </div>
          }
        </div>
      </div>
    }
  `,
  styles: [`
    .ad-banner-container {
      background: #f9fafb;
      border-top: 1px solid #e5e7eb;
      padding: 10px;
      margin-top: 12px;
    }

    .ad-banner-label {
      display: block;
      font-size: 9px; font-weight: 500; color: #9ca3af;
      text-transform: uppercase; letter-spacing: 0.05em;
      margin-bottom: 6px;
    }

    .ad-banner {
      width: 100%;
      border-radius: 6px;
      overflow: hidden;
      cursor: pointer;
    }

    .ad-banner-img {
      width: 100%; display: block;
      max-height: 250px; object-fit: contain;
      background: #F9FAFB;
    }

    .ad-banner-fallback {
      width: 100%; min-height: 80px;
      background: linear-gradient(135deg, #1565C0, #0D47A1);
      border-radius: 6px; padding: 16px;
      display: flex; flex-direction: column; align-items: center; justify-content: center;
      color: white; text-align: center;
    }

    .ad-banner-headline { font-size: 14px; font-weight: 600; }
    .ad-banner-desc { font-size: 11px; opacity: 0.8; margin-top: 4px; }
    .ad-banner-cta {
      display: inline-block; margin-top: 8px;
      padding: 4px 14px; background: rgba(255,255,255,0.2);
      border-radius: 4px; font-size: 12px; font-weight: 500;
    }
  `]
})
export class AdBannerComponent implements OnInit {
  @Input() placement = '';
  private adService = inject(AdService);
  ad: ServedAd | null = null;

  ngOnInit() {
    this.adService.getAd(this.placement).subscribe(ad => this.ad = ad);
  }

  onClick() {
    if (this.ad) this.adService.recordClick(this.ad);
  }

  formatCta(cta: string): string {
    return cta.replace(/_/g, ' ').replace(/\b\w/g, l => l.toUpperCase());
  }
}
